import { render, staticRenderFns } from "./ReviewInvoiceIssues.vue?vue&type=template&id=18108a4f&scoped=true&"
import script from "./ReviewInvoiceIssues.vue?vue&type=script&lang=js&"
export * from "./ReviewInvoiceIssues.vue?vue&type=script&lang=js&"
import style0 from "./ReviewInvoiceIssues.vue?vue&type=style&index=0&id=18108a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18108a4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18108a4f')) {
      api.createRecord('18108a4f', component.options)
    } else {
      api.reload('18108a4f', component.options)
    }
    module.hot.accept("./ReviewInvoiceIssues.vue?vue&type=template&id=18108a4f&scoped=true&", function () {
      api.rerender('18108a4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReviewInvoiceIssues.vue"
export default component.exports